import { ReactNode, useId, useState } from 'react'
import { ActionButton } from '@fluentui/react'

type DisclosureProps = {
  label: string
  children: ReactNode
}

const Disclosure = ({ label, children }: DisclosureProps) => {
  const [isExpanded, setIsExpanded] = useState(false)
  const regionId = useId()

  return (
    <div>
      <ActionButton
        iconProps={{ iconName: isExpanded ? 'ChevronDown' : 'ChevronRight' }}
        aria-expanded={isExpanded}
        aria-controls={regionId}
        onClick={() => setIsExpanded((expanded) => !expanded)}
        styles={{ root: { paddingLeft: 0, height: 32 } }}
      >
        {label}
      </ActionButton>
      <div id={regionId} hidden={!isExpanded}>
        {isExpanded && children}
      </div>
    </div>
  )
}

export default Disclosure
